export default __webpack_public_path__ + "static/spectrum-c1091751c74ca5cd0a0f5a8a359942f8.svg";